import React, { useState, useRef, useEffect } from 'react';
import ChrModal from '../../../../generic/Utils/ChrModal';
import SpinningLoader from '../../../../generic/Utils/SpinningLoader';
import i18n from '../../../../../utils/ChrI18n';
import ChronusApi from '../../../../../services/ChronusApi';
import RegistrationInput from './RegistrationInput';
import ConfettiModal from './ConfettiModal';

const NewMemberModal = props => {
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [email, setEmail] = useState();
  const [errorFields, setErrorFields] = useState([]);
  const [registerInProgress, setRegisterInProgress] = useState(false);
  const [confettiModalContent, setConfettiModalContent] = useState();

  const memberCreateUrl = useRef();
  const termsAndConditionsText = useRef();
  const errorFlashMessage = useRef([]);
  const isResponseReceived = useRef(false);

  const setErrorFieldsAndError = (errorField, errorMessage) => {
    setErrorFields(errorFields => {
      return errorFields + errorField;
    });
    errorFlashMessage.current.push(errorMessage);
  };

  const cantBlankErrorMessage = prefix => `${prefix} ${i18n.t('activerecord.errors.messages.blank')}`;

  const validateForm = () => {
    if(!firstName)
      setErrorFieldsAndError('firstName', cantBlankErrorMessage(i18n.t('activerecord.attributes.member.first_name')));
    if(!lastName)
      setErrorFieldsAndError('lastName', cantBlankErrorMessage(i18n.t('activerecord.attributes.member.last_name')));

    if(!email)
      setErrorFieldsAndError('email', cantBlankErrorMessage(i18n.t('activerecord.attributes.member.email')));
    if(email && !EmailFormat.verify(email))
      setErrorFieldsAndError('email', `${i18n.t('activerecord.attributes.member.email')} ${i18n.t('activerecord.custom_errors.permission.invalid')}`);

    return errorFlashMessage.current.length === 0;
  };

  const onClickRegister = () => {
    setErrorFields([]);

    if(validateForm()) {
      setRegisterInProgress(true);
      ChronusApi.postUrlJSON(
        memberCreateUrl.current,
        {
          firstName, lastName, email,
          timeZone: TimeZoneUtils.computeTimeZone(props.notifyNewTimezoneUrl, true)
        }
      ).then(response => {
        setConfettiModalContent(response.data);
      }).catch(_error => {
        setRegisterInProgress(false);
        ChronusValidator.ErrorManager.ShowPageFlash(false, i18n.t("common_text.error_msg.something_went_wrong"));
      });
    }
    else {
      ChronusValidator.ErrorManager.showErrorFlash(errorFlashMessage.current.join("<br>"));
      errorFlashMessage.current = [];
    }
  };

  const registerButton = <button key='register' className='btn btn-primary btn-rounded-5 my-1' onClick={ onClickRegister } disabled={ registerInProgress }>
    { i18n.t('display_string.register') }
  </button>;

  useEffect(() => {
    ChronusApi.getUrlJSON(props.url).then(response => {
      isResponseReceived.current = true;
      setFirstName(response.memberAttributes.firstName || '');
      setLastName(response.memberAttributes.lastName || '');
      setEmail(response.memberAttributes.email || '');
      memberCreateUrl.current = response.url;
      termsAndConditionsText.current = response.termsAndConditionsText;
    }).catch(_error => {
      ChronusValidator.ErrorManager.ShowPageFlash(false, i18n.t("common_text.error_msg.something_went_wrong"));
    });
  }, []);

  return(
    <>
      {
        confettiModalContent ?
          <ConfettiModal
            modalOptions={ props.modalOptions }
            modalContent={ confettiModalContent }
            reloadPageOnModalClose
          /> :
          <ChrModal
            header={ i18n.t('display_string.register') }
            footer={ registerButton }
            closeActionText={ i18n.t('display_string.Cancel') }
            closeActionClassName='cui-rounded-btn-white my-1'
            includeCloseAction
            { ...props.modalOptions }
          >
            {
              isResponseReceived.current ? <div className='row mx-0'>
                <RegistrationInput
                  label={ i18n.t('activerecord.attributes.member.first_name') }
                  value={ firstName }
                  fieldName='firstName'
                  valueSetter={ setFirstName }
                  errorFields={ errorFields }
                  formGroupClass='col-6 pl-0 pr-1'
                />
                <RegistrationInput
                  label={ i18n.t('activerecord.attributes.member.last_name') }
                  value={ lastName }
                  fieldName='lastName'
                  valueSetter={ setLastName }
                  errorFields={ errorFields }
                  formGroupClass='col-6 pr-0 pl-1'
                />
                <RegistrationInput
                  label={ i18n.t('activerecord.attributes.member.email') }
                  value={ email }
                  fieldName='email'
                  valueSetter={ setEmail }
                  errorFields={ errorFields }
                  formGroupClass='col-12 px-0'
                />

                <div dangerouslySetInnerHTML={{ __html: termsAndConditionsText.current }} />
              </div> :
              <SpinningLoader />
            }
          </ChrModal>
      }
    </>
  );
};

export default NewMemberModal;